import gql from 'graphql-tag';

const ReattachClaimsPassengerTickets = gql`
  mutation ReattachClaimsPassengerTickets(
    $input: ReattachClaimsPassengerTicketsMutationInput!
  ) {
    reattachClaimsPassengerTickets(input: $input) {
      claimsPassengerTickets {
        id
        claimId
        passengerTicketId
        claim {
          id
          claimsPassengerTicketConnection {
            edges {
              node {
                id
                promoCode {
                  id
                  code
                  percentage
                }
                documentsConnection {
                  edges {
                    cursor
                    node {
                      documentId
                      id
                      attachmentContentType
                      documentUrl
                      status
                      conflictsWithClaim
                      formAttributes
                      type
                    }
                  }
                }
                loa {
                  id
                  myclaimUrl
                  signedLoaDocumentUrl
                }
                passengerTicket {
                  id
                  pnr
                  number
                  passengerFirstName
                  passengerLastName
                  passengerPhone
                  passengerEmail
                  passengerLanguage
                  employer
                  profession
                  gender
                  nationality
                  dateOfBirth
                  street
                  city
                  postCode
                  country
                  bankInformation
                  affiliate {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export { ReattachClaimsPassengerTickets };



// WEBPACK FOOTER //
// ./src/mutations/ReattachClaimsPassengerTickets.js